// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4OeRevdmx{text-decoration:none;color:inherit;width:100%}._1Sqyjpndx{padding-top:16px;display:flex;direction:row;justify-content:space-between;border-bottom:solid 1px #DEDEDE;padding-bottom:16px;background-color:#FFFFFF}._7mVX7h5Xx{opacity:.5}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"list-item-link": "_4OeRevdmx",
	"listItemLink": "_4OeRevdmx",
	"list-item": "_1Sqyjpndx",
	"listItem": "_1Sqyjpndx",
	"list-item-grayed": "_7mVX7h5Xx _1Sqyjpndx",
	"listItemGrayed": "_7mVX7h5Xx _1Sqyjpndx"
};
module.exports = exports;
